var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.035 0C5.833 0 0 5.846 0 13.048c0 7.203 5.833 13.048 13.035 13.048 7.216 0 13.061-5.845 13.061-13.048C26.096 5.846 20.251 0 13.036 0zm.013 23.487A10.436 10.436 0 012.61 13.048 10.436 10.436 0 0113.048 2.61a10.436 10.436 0 0110.439 10.438 10.436 10.436 0 01-10.439 10.439z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.091 6.524H9.134v7.83l6.85 4.11.979-1.605-5.872-3.484v-6.85z"
  })));
}
export default SvgClock;